import React from "react"
import logo from "../assets/img/Logo.svg"
import { useTranslation } from "react-i18next"

function Footer() {
  const { t } = useTranslation()
  return (
    <footer
      id="website-footer"
      className="uk-child-width-1-3@l font-white bg-red"
      uk-grid="true"
    >
      <div>
        <div>
          <img
            src={logo}
            alt="anak indonesia bersatu"
            width="50"
            height="50"
            className="uk-margin-right uk-margin-remove-vertical"
          />
          <span
            className="uk-text-middle uk-text-bold"
            style={{ fontSize: 20 }}
          >
            Anak Indonesia Bersatu
          </span>
        </div>
      </div>
      <div id="contacts">
        <div>
          <p className="uk-text-bold">
            <span
              className="uk-margin-small-right"
              uk-icon="icon: location; ratio: 1"
            ></span>
            Jakarta, Indonesia
          </p>
        </div>
        <div>
          <p className="uk-text-bold">
            <span
              className="uk-margin-small-right"
              uk-icon="icon: receiver; ratio: 1"
            ></span>
            +62 819 0278 2721
          </p>
        </div>
        <div>
          <p>
            <span
              className="uk-margin-small-right"
              uk-icon="icon: mail; ratio: 1"
            ></span>
            anakindonesiaber1@gmail.com
          </p>
        </div>
      </div>
      <div>
        <p className="uk-text-bold font-white">Anak Indonesia Bersatu</p>
        <p className="uk-text-light font-white" style={{ fontSize: 13 }}>
          {t("footer.desc")}
        </p>
        <a
          href="https://www.instagram.com/anakindonesiabersatu"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="socmed-icon fab fa-instagram uk-margin-right uk-text-secondary"></i>
        </a>

        <a
          href="https://www.tiktok.com/@anakindonesiaber1"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="socmed-icon fab fa-tiktok uk-margin-right uk-text-secondary"></i>
        </a>
        <a
          href="http://wa.me/6281902782721"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="socmed-icon fab fa-whatsapp uk-margin-right uk-text-secondary"></i>
        </a>
      </div>
    </footer>
  )
}

export default Footer
